import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CountryCode, isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

export function phoneUEValidator(defaultRegion = 'ES', required = true): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let phoneNumber: string = control.value || '';

    phoneNumber = phoneNumber.trim();

    if (!required && !phoneNumber) {
      return null;
    }

    if (required && !phoneNumber) {
      return { required: { message: 'error.required_phone' } };
    }

    // Has country code
    if (phoneNumber.startsWith('+')) {
      const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);

      if (!parsedPhoneNumber || !parsedPhoneNumber.isValid()) {
        return { invalidPhone: { message: 'error.invalid_phone' } };
      }

      // TODO for now, all countries are allowed
      // UE / EEA country
      // if (!parsedPhoneNumber.country || !EEA_COUNTRIES.includes(parsedPhoneNumber.country)) {
      //   return { invalidPhoneRegion: true, message: 'error.invalid_phone_region' };
      // }

      return null;
    }

    // Don't have a country code, default country (ES)
    if (
      !isValidPhoneNumber(phoneNumber, {
        defaultCountry: defaultRegion as CountryCode,
      })
    ) {
      return { invalidPhone: { message: 'error.invalid_phone' } };
    }

    return null;
  };
}
